/* Plan W · todos los textos del resultado (versión 2026-10-22).
   Para cambiar un texto, búscalo aquí con Ctrl+F y cámbialo entre las comillas, sin tocar las comillas ni las comas.
   Si lo cambias, apúntalo también en el mapa de piezas para que la próxima versión lo mantenga. */
window.PLANW_CONTENIDO = {
 "version": "2026-10-22",
 "etapas": {
  "peri": "Perimenopausia",
  "meno": "Menopausia",
  "post": "Postmenopausia"
 },
 "sintomas": {
  "sofocos": {
   "etiqueta": "Sofocos",
   "modulo": "core",
   "dato": {
    "cifra": "7,4 años",
    "frase": "es lo que duran de media los sofocos frecuentes."
   }
  },
  "animo": {
   "etiqueta": "Ánimo inestable",
   "modulo": "core",
   "dato": null
  },
  "hinchazon": {
   "etiqueta": "Hinchazón",
   "modulo": "core",
   "dato": null
  },
  "sueno": {
   "etiqueta": "Dormir mal",
   "modulo": "sueno",
   "dato": {
    "cifra": "1 de cada 3",
    "frase": "mujeres en tu etapa duerme así.",
    "solo": "peri"
   }
  },
  "niebla": {
   "etiqueta": "Niebla mental",
   "modulo": "niebla",
   "dato": {
    "cifra": "6 de cada 10",
    "frase": "mujeres notan problemas de memoria en esta etapa."
   }
  },
  "deseo": {
   "etiqueta": "Menos deseo",
   "modulo": "libido",
   "dato": {
    "cifra": "7 de cada 10",
    "frase": "mujeres de 40 a 65 años tienen el deseo bajo."
   }
  },
  "sequedad": {
   "etiqueta": "Sequedad íntima",
   "modulo": "libido",
   "dato": null
  },
  "fuerza": {
   "etiqueta": "Menos fuerza",
   "modulo": "rm",
   "dato": {
    "cifra": "7 de cada 10",
    "frase": "mujeres tienen molestias en músculos o articulaciones durante la transición."
   }
  },
  "cansancio": {
   "etiqueta": "Cansancio",
   "modulo": "core",
   "dato": null
  }
 },
 "modulos": {
  "sueno": {
   "nombre": "Sueño",
   "preguntas": {
    "p6": {
     "cuesta_dormir": {
      "id": "MO-SUE-01",
      "texto": "Para dormirte, tu temperatura tiene que bajar: date una ducha templada una o dos horas antes de acostarte.",
      "donde": "descansa",
      "frag": "te cuesta dormirte",
      "cita": "Me cuesta dormirme",
      "prio": 3
     },
     "madrugada": {
      "id": "MO-SUE-02",
      "texto": "Que te despiertes casi a la misma hora no es casualidad: en la segunda mitad de la noche el sueño es más ligero, y con el freno flojo esos pequeños despertares se vuelven completos.",
      "donde": "descansa",
      "frag": "te despiertas de madrugada, casi siempre a la misma hora",
      "cita": "Me despierto de madrugada",
      "prio": 1
     },
     "calor": {
      "id": "MO-SUE-03",
      "texto": "Dormitorio fresco, entre 16 y 18 °C, y ropa de cama por capas. Si te despiertas con calor, destápate, saca un pie o gira la almohada al lado frío.",
      "donde": "descansa",
      "frag": "te despiertas con calor o sudando",
      "cita": "Me despierto con calor",
      "prio": 4
     },
     "agotada": {
      "id": "MO-SUE-04",
      "texto": "Si duermes horas y te levantas agotada, pide que te descarten la apnea del sueño: aumenta tras la menopausia y en las mujeres se disfraza de cansancio.",
      "donde": "consultar",
      "frag": "aunque duermas, te levantas agotada",
      "cita": "Me levanto agotada",
      "prio": 5
     },
     "cabeza": {
      "id": "MO-SUE-05",
      "texto": "Cambia la frase: «Si no duermo ocho horas, mañana será un desastre» enciende la alarma; «He tenido otras noches así y he funcionado» la apaga.",
      "donde": "descansa",
      "frag": "en cuanto abres los ojos tu cabeza se pone en marcha y ya no hay quien la pare",
      "cita": "Mi cabeza no se apaga",
      "prio": 2,
      "alt": "en cuanto apagas la luz tu cabeza se pone en marcha y ya no hay quien la pare"
     }
    },
    "p7": {
     "1-2": {
      "id": "MO-SUE-06",
      "texto": "Son pocas noches, y es el mejor momento para cortarlo antes de que se convierta en costumbre.",
      "donde": "caso",
      "frag": "una o dos noches por semana",
      "cita": "Una o dos noches por semana",
      "prio": 1
     },
     "3-4": {
      "id": "MO-SUE-07",
      "texto": "Es la mitad de tu semana: merece un plan, no esperar a que se pase solo.",
      "donde": "caso",
      "frag": "tres o cuatro noches por semana",
      "cita": "Tres o cuatro noches por semana",
      "prio": 1
     },
     "casi_todas": {
      "id": "MO-SUE-08",
      "texto": "Dormir mal casi todas las noches no es una mala racha. Por eso te recomendamos la pauta completa de 3 meses.",
      "donde": "formula",
      "frag": "casi todas las noches",
      "cita": "Casi todas las noches",
      "prio": 1
     }
    },
    "p8": {
     "hora": {
      "id": "MO-SUE-09",
      "texto": "Gira el reloj esta noche: mirar la hora enciende la cuenta atrás de «si me duermo ya, aún me quedan cuatro horas».",
      "donde": "descansa",
      "frag": "lo primero que haces es mirar la hora",
      "cita": "Miro la hora",
      "prio": 1
     },
     "movil": {
      "id": "MO-SUE-10",
      "texto": "Deja el móvil fuera del dormitorio: su luz y sus mensajes despiertan a tu cerebro justo cuando necesita frenar.",
      "donde": "descansa",
      "frag": "lo primero que haces es coger el móvil",
      "cita": "Cojo el móvil",
      "prio": 1
     },
     "vueltas": {
      "id": "MO-SUE-11",
      "texto": "Si a los 20 minutos sigues despierta, levántate, ve a otra habitación con luz tenue y haz algo tranquilo hasta que vuelva el sueño.",
      "donde": "descansa",
      "frag": "te quedas dando vueltas en la cama",
      "cita": "Me quedo dando vueltas",
      "prio": 1
     },
     "levanto": {
      "id": "MO-SUE-12",
      "texto": "Haces bien en levantarte: que sea con luz tenue y sin pantallas, y vuelve a la cama cuando notes sueño.",
      "donde": "descansa",
      "frag": "acabas levantándote de la cama",
      "cita": "Me levanto",
      "prio": 1
     },
     "duermo": {
      "id": "MO-SUE-13",
      "texto": "Tus despertares no te roban la noche, así que tu plan se centra en que lleguen menos.",
      "donde": "descansa",
      "frag": "por suerte, te vuelves a dormir enseguida",
      "cita": "Me vuelvo a dormir enseguida",
      "prio": 1
     }
    }
   },
   "historia": {
    "peri": {
     "titulo": "Tu freno para dormir ha perdido a su ayudante.",
     "pasos": [
      {
       "t": "Tu cerebro tiene un freno.",
       "d": "Imagina que tu cerebro es un coche. De día va acelerado: el trabajo, la casa, las cosas pendientes. Por la noche, para dormir, necesita frenar. Y tiene un freno de verdad: una sustancia que fabrica tu propio cerebro para calmarse, que se llama GABA. Cuando funciona bien, los pensamientos se apagan y los pequeños despertares de la noche pasan sin que te enteres."
      },
      {
       "t": "Durante años tuvo una ayudante.",
       "d": "La progesterona, una de tus hormonas. Se fabrica cada mes después de ovular y, dentro del cerebro, se convierte en un calmante natural que hace que el freno apriete con más fuerza."
      },
      {
       "t": "En tu etapa, la ayudante se va.",
       "d": "En la perimenopausia ovulas menos veces, así que la progesterona es de las primeras hormonas en bajar. El freno sigue ahí, pero sin su ayudante. Por eso tu cabeza se enciende y no se apaga, y te despiertas de madrugada, muchas veces a la misma hora. A muchas mujeres les pasa antes incluso de tener sofocos."
      }
     ],
     "buena": "No es que se te haya olvidado dormir, ni que seas una persona nerviosa: es que tu freno necesita ayuda. Y se le puede ayudar desde fuera, con hábitos que bajan las revoluciones, y desde dentro, con una fórmula pensada para él. De eso va tu plan."
    },
    "otras": {
     "titulo": "Tu noche ha cambiado de reglas.",
     "pendiente": true,
     "pasos": [
      {
       "t": "Tu cerebro tiene un freno.",
       "d": "Imagina que tu cerebro es un coche. De día va acelerado: el trabajo, la casa, las cosas pendientes. Por la noche, para dormir, necesita frenar. Y tiene un freno de verdad: una sustancia que fabrica tu propio cerebro para calmarse, que se llama GABA. Cuando funciona bien, los pensamientos se apagan y los pequeños despertares de la noche pasan sin que te enteres."
      },
      {
       "t": "Tus hormonas lo ayudaban.",
       "d": "Durante años, tus hormonas ayudaban a ese freno y mantenían tranquilo el termostato que regula tu temperatura por la noche."
      },
      {
       "t": "Ahora el termostato salta antes.",
       "d": "Con menos estrógenos, un cambio pequeño de temperatura basta para despertarte: calor, sudor o un despertar sin motivo en mitad de la noche."
      }
     ],
     "buena": "No es que se te haya olvidado dormir: tu noche funciona con otras reglas. Se le puede ayudar desde fuera, con un dormitorio fresco y hábitos que bajan las revoluciones, y desde dentro, con una fórmula pensada para tu freno. De eso va tu plan."
    }
   },
   "primerPaso": [
    {
     "id": "PP-01",
     "si": [
      "p8:movil",
      "p6:madrugada"
     ],
     "titular": "Si te despiertas, deja el móvil donde está y haz cinco suspiros cíclicos.",
     "pasos": [
      "Toma aire por la nariz.",
      "Cuando estés llena, toma un poquito más, también por la nariz.",
      "Suelta todo el aire muy despacio por la boca. Repítelo cinco veces."
     ],
     "porque": "Soltar el aire despacio es la forma más rápida que tienes de decirle a tu cuerpo que puede relajarse.",
     "anim": true,
     "excluye": []
    },
    {
     "id": "PP-03",
     "si": [
      "p6:calor"
     ],
     "titular": "Esta noche, prepara tu dormitorio para el calor.",
     "pasos": [
      "Deja la habitación entre 16 y 18 °C.",
      "Pon la ropa de cama por capas, para quitarte una sin despertarte del todo.",
      "Si te despiertas con calor, saca un pie o gira la almohada al lado frío."
     ],
     "porque": "Para dormirte, tu temperatura tiene que bajar, y un dormitorio fresco se lo pone fácil.",
     "anim": false,
     "excluye": [
      "MO-SUE-03"
     ]
    },
    {
     "id": "PP-18",
     "si": [
      "p6:cabeza"
     ],
     "titular": "Esta noche, vacía la cabeza antes de acostarte.",
     "pasos": [
      "Una hora antes de dormir, apunta en un papel lo que te preocupa.",
      "Al lado de cada cosa, escribe el primer paso para mañana.",
      "Deja la libreta fuera del dormitorio."
     ],
     "porque": "Lo que está en el papel ya no tiene que dar vueltas en tu cabeza.",
     "anim": false,
     "excluye": [
      "MO-SUE-05"
     ]
    },
    {
     "id": "PP-17",
     "si": [
      "p6:agotada"
     ],
     "titular": "Esta semana, apunta cómo te levantas.",
     "pasos": [
      "Cada mañana, puntúa del 1 al 10 cómo te has levantado.",
      "Pregunta en casa si roncas o haces pausas al respirar.",
      "Si te levantas agotada a menudo, coméntalo con tu médico."
     ],
     "porque": "Si duermes horas y te levantas agotada, puede que tu sueño no esté siendo reparador, y la apnea del sueño aumenta tras la menopausia.",
     "anim": false,
     "excluye": []
    },
    {
     "id": "PP-02",
     "si": [
      "*"
     ],
     "titular": "Esta noche, la cama es solo para dormir.",
     "pasos": [
      "Deja el móvil fuera del dormitorio.",
      "Nada de series ni de repasar preocupaciones en la cama.",
      "Si a los 20 minutos sigues despierta, levántate y vuelve cuando tengas sueño."
     ],
     "porque": "Tu cerebro tiene que volver a asociar la cama con dormir, no con dar vueltas.",
     "anim": false,
     "excluye": [
      "MO-SUE-11"
     ]
    }
   ],
   "puentes": {
    "nutrete": "Deja el último café nueve horas antes de acostarte: sigue haciendo efecto muchas horas después de tomarlo. Si te acuestas a las 23:00, a las 14:00.",
    "muevete": "La fuerza es el ejercicio que más ha mejorado el sueño en los estudios, además de cuidar tus músculos y tus huesos.",
    "descansa": "Si a los 20 minutos sigues despierta, levántate y haz algo tranquilo con luz tenue: tu cerebro tiene que volver a asociar la cama con dormir.",
    "conecta": "Sentirse sola mantiene encendida la alarma interna, y esa alarma es la que te encuentra a las tres de la madrugada."
   },
   "cierre": "Dale a tus noches tres meses, no tres noches."
  },
  "niebla": {
   "nombre": "Niebla Mental",
   "preguntas": {
    "p6": {
     "palabra": {
      "id": "MO-NIE-01",
      "texto": "Cuando te quedes en blanco, no luches: describe lo que quieres decir con otras palabras y la que buscas suele aparecer sola.",
      "donde": "descansa",
      "frag": "la palabra se te queda en la punta de la lengua",
      "cita": "La palabra se me queda en la punta de la lengua",
      "prio": 2
     },
     "hilo": {
      "id": "MO-NIE-02",
      "texto": "Haz una cosa cada vez y silencia las notificaciones: cada vez que saltas de una tarea a otra, tu memoria de trabajo se vacía un poco.",
      "donde": "descansa",
      "frag": "pierdes el hilo a mitad de frase",
      "cita": "Pierdo el hilo",
      "prio": 1
     },
     "habitacion": {
      "id": "MO-NIE-03",
      "texto": "Vuelve a donde estabas: el contexto te lo devuelve. Y ríete un poco, porque le pasa a la mayoría.",
      "donde": "descansa",
      "frag": "entras en una habitación y no sabes a qué ibas",
      "cita": "Entro en una habitación y no sé a qué",
      "prio": 4
     },
     "concentrar": {
      "id": "MO-NIE-04",
      "texto": "Trabaja en bloques de 25 minutos de concentración y 5 de descanso: tu atención rinde más a ráfagas.",
      "donde": "descansa",
      "frag": "te cuesta concentrarte o hacer varias cosas a la vez",
      "cita": "Me cuesta concentrarme",
      "prio": 3
     },
     "tarde": {
      "id": "MO-NIE-05",
      "texto": "Un vaso de agua al levantarte y una botella a la vista: con una deshidratación leve, la concentración ya baja. Y fruta con un puñado de nueces a media mañana, en lugar de galletas.",
      "donde": "nutrete",
      "frag": "a media tarde te apagas",
      "cita": "A media tarde me apago",
      "prio": 5
     }
    },
    "p7": {
     "no": {
      "id": "MO-NIE-06",
      "texto": "Es la etapa, y en la mayoría de las mujeres estas dificultades mejoran cuando el cerebro se adapta.",
      "donde": "caso",
      "frag": "",
      "cita": "De momento no me preocupa",
      "prio": 9
     },
     "a_veces": {
      "id": "MO-NIE-07",
      "texto": "Te lo decimos claro: en los estudios, la memoria baja en la perimenopausia y se recupera después. Aun así, si la niebla es muy intensa, empeora con los meses o afecta a tu día a día, coméntalo con tu médico y pide que te miren el tiroides, el hierro y la vitamina B12.",
      "donde": "consultar",
      "frag": "",
      "cita": "A veces lo pienso",
      "prio": 9
     },
     "si": {
      "id": "MO-NIE-07",
      "texto": "Te lo decimos claro: en los estudios, la memoria baja en la perimenopausia y se recupera después. Aun así, si la niebla es muy intensa, empeora con los meses o afecta a tu día a día, coméntalo con tu médico y pide que te miren el tiroides, el hierro y la vitamina B12.",
      "donde": "consultar",
      "frag": "",
      "cita": "A veces lo pienso",
      "prio": 9
     }
    },
    "p8": {
     "ninguno": {
      "id": "MO-NIE-08",
      "texto": "Tu cerebro no depende del café: vamos a cuidar su combustible desde el plato.",
      "donde": "nutrete",
      "frag": "no tomas café",
      "cita": "Ningún café",
      "prio": 1
     },
     "1-2": {
      "id": "MO-NIE-09",
      "texto": "Tómalos con el desayuno, y que el último sea nueve horas antes de acostarte para que no te robe la noche.",
      "donde": "nutrete",
      "frag": "tomas uno o dos cafés al día",
      "cita": "Uno o dos cafés",
      "prio": 1
     },
     "3mas": {
      "id": "MO-NIE-10",
      "texto": "Si necesitas el tercer café para funcionar, tu cerebro te está pidiendo combustible, no más estímulo: agua al levantarte, desayuno con proteína y cinco minutos de paseo cada hora.",
      "donde": "nutrete",
      "frag": "necesitas tres cafés o más para tirar del día",
      "cita": "Tres cafés o más",
      "prio": 1
     }
    }
   },
   "historia": {
    "peri": {
     "titulo": "Tu cerebro está de obras.",
     "entrada": "¿Te ha pasado entrar en una habitación y no saber a qué ibas? ¿Tener una palabra en la punta de la lengua y que no salga? No te estás volviendo despistada. Te lo explicamos.",
     "pasos": [
      {
       "t": "Tus neuronas necesitan energía.",
       "d": "Tu cerebro está formado por miles de millones de neuronas, las células que piensan, recuerdan y encuentran las palabras. Como cualquier célula, necesitan energía, y la sacan sobre todo del azúcar que les llega por la sangre."
      },
      {
       "t": "Los estrógenos las ayudaban.",
       "d": "Los estrógenos, las hormonas que más cambian en esta etapa, ayudan a tus neuronas a aprovechar esa energía y a mantener sus conexiones rápidas."
      },
      {
       "t": "Ahora tu cerebro está de obras.",
       "d": "Cuando los estrógenos empiezan a bajar, tu cerebro tiene que reorganizarse para conseguir energía de otra forma. Es como vivir en una casa mientras la reforman: sigue funcionando, pero hay polvo, cosas fuera de sitio y todo cuesta un poco más. Por eso te cansas antes al concentrarte o tardas en encontrar una palabra."
      }
     ],
     "buena": "No te estás volviendo despistada. Los estudios que han seguido a miles de mujeres muestran que la memoria baja en la perimenopausia y se recupera después, cuando el cerebro se estabiliza. Mientras dura la obra, puedes ayudarle con lo que necesita: buen combustible, oxígeno y descanso. De eso va tu plan."
    },
    "otras": {
     "titulo": "Tu cerebro está de obras.",
     "entrada": "¿Te ha pasado entrar en una habitación y no saber a qué ibas? ¿Tener una palabra en la punta de la lengua y que no salga? No te estás volviendo despistada. Te lo explicamos.",
     "pendiente": true,
     "pasos": [
      {
       "t": "Tus neuronas necesitan energía.",
       "d": "Tu cerebro está formado por miles de millones de neuronas, las células que piensan, recuerdan y encuentran las palabras. Como cualquier célula, necesitan energía, y la sacan sobre todo del azúcar que les llega por la sangre."
      },
      {
       "t": "Los estrógenos las ayudaban.",
       "d": "Los estrógenos, las hormonas que más cambian en esta etapa, ayudan a tus neuronas a aprovechar esa energía y a mantener sus conexiones rápidas."
      },
      {
       "t": "Ahora tu cerebro está de obras.",
       "d": "Cuando los estrógenos empiezan a bajar, tu cerebro tiene que reorganizarse para conseguir energía de otra forma. Es como vivir en una casa mientras la reforman: sigue funcionando, pero hay polvo, cosas fuera de sitio y todo cuesta un poco más. Por eso te cansas antes al concentrarte o tardas en encontrar una palabra."
      }
     ],
     "buena": "No te estás volviendo despistada. Tu cerebro sigue aprendiendo a funcionar con menos estrógenos, y puedes ayudarle con lo que necesita: buen combustible, oxígeno, movimiento y descanso. De eso va tu plan."
    }
   },
   "primerPaso": [
    {
     "id": "PP-04",
     "si": [
      "p6:palabra"
     ],
     "titular": "Mañana, cuando una palabra no salga, no luches: rodéala.",
     "pasos": [
      "Describe lo que quieres decir con otras palabras.",
      "Sigue hablando sin pararte.",
      "Casi siempre, la palabra que buscabas aparece sola."
     ],
     "porque": "Cuanto más la persigues, más se esconde: rodearla le da a tu cerebro otro camino para llegar a ella.",
     "anim": false,
     "excluye": [
      "MO-NIE-01"
     ]
    },
    {
     "id": "PP-19",
     "si": [
      "p6:hilo",
      "p6:habitacion"
     ],
     "titular": "Mañana, haz una cosa cada vez.",
     "pasos": [
      "Silencia las notificaciones mientras trabajas.",
      "Termina una tarea antes de empezar otra.",
      "Si entras en una habitación y no sabes a qué, vuelve a donde estabas: el contexto te lo devuelve."
     ],
     "porque": "Cada vez que saltas de una tarea a otra, tu memoria de trabajo se vacía un poco.",
     "anim": false,
     "excluye": [
      "MO-NIE-02",
      "MO-NIE-03"
     ]
    },
    {
     "id": "PP-06",
     "si": [
      "p6:tarde"
     ],
     "titular": "Mañana, empieza el día con un vaso de agua.",
     "pasos": [
      "Bebe un vaso de agua nada más levantarte.",
      "Ten una botella siempre a la vista.",
      "A media mañana, fruta con un puñado de nueces en lugar de galletas."
     ],
     "porque": "Con una deshidratación leve, la concentración ya baja, y el bajón de la tarde empieza a fraguarse por la mañana.",
     "anim": false,
     "excluye": [
      "MO-NIE-05"
     ]
    },
    {
     "id": "PP-05",
     "si": [
      "*"
     ],
     "titular": "Mañana, trabaja a ráfagas.",
     "pasos": [
      "Elige una sola tarea.",
      "Concéntrate 25 minutos con el móvil en silencio.",
      "Descansa 5 minutos y vuelve a empezar."
     ],
     "porque": "Tu atención rinde más a ráfagas cortas que en una maratón.",
     "anim": false,
     "excluye": [
      "MO-NIE-04"
     ]
    }
   ],
   "puentes": {
    "nutrete": "Tu cerebro funciona con el combustible que le das: un desayuno con proteína y comidas a horas regulares evitan los bajones que luego notas en tu concentración.",
    "muevete": "Moverte también es oxígeno para tu cerebro: cinco minutos de paseo cada hora despejan más que otro café.",
    "descansa": "Lo que más despeja tu cabeza es tu noche: mientras duermes, tu cerebro limpia y ordena lo del día. Protege tus horas de sueño como protegerías una reunión importante.",
    "conecta": "Reírte de tus despistes con alguien que pasa por lo mismo les quita peso: el miedo a estar perdiendo la cabeza cansa más que los propios olvidos."
   },
   "cierre": "Dale a tu cabeza tres meses, no tres días."
  },
  "libido": {
   "nombre": "Libido",
   "preguntas": {
    "p6": {
     "apetece": {
      "id": "MO-LIB-01",
      "texto": "En las relaciones largas, para muchas mujeres el deseo aparece después de empezar, con la cercanía. Se llama deseo responsivo y no es un deseo roto: es otra forma de desear.",
      "donde": "conecta",
      "frag": "no te apetece como antes",
      "cita": "No me apetece como antes",
      "prio": 1
     },
     "excitar": {
      "id": "MO-LIB-02",
      "texto": "La excitación es, sobre todo, riego. Veinte minutos de bici, baile o un paseo rápido en la hora previa pueden facilitarla.",
      "donde": "muevete",
      "frag": "tardas más en excitarte",
      "cita": "Tardo más en excitarme",
      "prio": 3
     },
     "sensibilidad": {
      "id": "MO-LIB-03",
      "texto": "Lubricante, sin vergüenza: no es un fracaso, es como ponerse gafas para leer. Un hidratante vaginal ayuda en el día a día y un lubricante, durante las relaciones.",
      "donde": "conecta",
      "frag": "notas menos sensibilidad o sequedad",
      "cita": "Noto menos sensibilidad",
      "prio": 4
     },
     "cansada": {
      "id": "MO-LIB-04",
      "texto": "No es que no quieras, es que no te quedan fuerzas. Sin batería no hay ganas, y por eso tu plan empieza por tu energía.",
      "donde": "caso",
      "frag": "estás demasiado cansada para pensar en ello",
      "cita": "Estoy demasiado cansada",
      "prio": 2
     },
     "molestias": {
      "id": "MO-LIB-05",
      "texto": "Si duele, no es normal y no tienes que aguantarlo. Hay soluciones eficaces, desde hidratantes y lubricantes hasta estrógenos vaginales a dosis bajas: coméntalo con tu ginecóloga.",
      "donde": "consultar",
      "frag": "sientes molestias o dolor",
      "cita": "Siento molestias",
      "prio": 5
     }
    },
    "p7": {
     "bien": {
      "id": "MO-LIB-06",
      "texto": "Tu batería aguanta, así que tu plan se centra en la circulación y la sensibilidad.",
      "donde": "descansa",
      "frag": "llegas al final del día con la batería bien",
      "cita": "Mi batería, bien",
      "prio": 1
     },
     "justa": {
      "id": "MO-LIB-07",
      "texto": "Protege tus horas de sueño: dormir una hora más se asoció con más deseo al día siguiente.",
      "donde": "descansa",
      "frag": "llegas al final del día con la batería justa",
      "cita": "Mi batería, justa",
      "prio": 1
     },
     "rojo": {
      "id": "MO-LIB-08",
      "texto": "Con la batería en rojo, el cuerpo prioriza llegar al final del día, no el placer. Antes de pensar en el deseo, recarga: sueño, proteína en cada comida y reparte la carga.",
      "donde": "descansa",
      "frag": "llegas al final del día con la batería en rojo",
      "cita": "Mi batería, en rojo",
      "prio": 1
     }
    },
    "saltar": {
     "id": "MO-LIB-09",
     "texto": "Tu plan va directo a las tres llaves del deseo: energía, circulación y sensibilidad.",
     "donde": "caso",
     "frag": "tu deseo ha cambiado",
     "cita": "",
     "prio": 1
    }
   },
   "historia": {
    "todas": {
     "titulo": "Tu deseo no se ha ido: está dormido.",
     "entrada": "Solemos pensar en el deseo como un interruptor que se enciende o se apaga. En realidad funciona más como una cadena: para que llegue, tu cuerpo necesita primero tres cosas, en este orden.",
     "pasos": [
      {
       "t": "La primera llave es la energía.",
       "d": "Si llegas al final del día sin batería, tu cuerpo prioriza llegar a la cama, no el placer. Por eso tantas mujeres dicen «no es que no quiera, es que no puedo con mi alma»."
      },
      {
       "t": "La segunda es la circulación.",
       "d": "La excitación es, sobre todo, sangre que llega a la zona íntima: los tejidos se llenan, se lubrican y ganan sensibilidad. Los estrógenos ayudan a que los vasos sanguíneos respondan; cuando bajan, llega menos sangre y tardas más en excitarte."
      },
      {
       "t": "La tercera es la sensibilidad.",
       "d": "Con menos estrógenos, la piel de la zona íntima se vuelve más fina y más seca. Si notas menos, o incluso molestias, tu cerebro aprende a evitar ese momento, y el deseo se esconde todavía más."
      }
     ],
     "buena": "Por eso el deseo, que es lo último de la cadena, se queda dormido. Pero no ha desaparecido: se puede despertar, llave a llave. Y algo que quita mucha culpa: en las relaciones largas, a muchas mujeres el deseo ya no les llega «de la nada», sino después de empezar, con la cercanía. No es un deseo roto: es otra forma de desear."
    }
   },
   "primerPaso": [
    {
     "id": "PP-07",
     "si": [
      "p6:sensibilidad",
      "p6:molestias"
     ],
     "titular": "Esta semana, lubricante, sin vergüenza.",
     "pasos": [
      "Un hidratante vaginal para el día a día.",
      "Un lubricante durante las relaciones.",
      "Si duele, coméntalo con tu ginecóloga: hay soluciones eficaces."
     ],
     "porque": "No es un fracaso: es como ponerse gafas para leer.",
     "anim": false,
     "excluye": [
      "MO-LIB-03"
     ]
    },
    {
     "id": "PP-08",
     "si": [
      "p7:rojo"
     ],
     "titular": "Esta noche, acuéstate media hora antes.",
     "pasos": [
      "Pon una alarma para empezar a desconectar.",
      "Apunta las tareas pendientes para mañana.",
      "A la cama, sin pantallas."
     ],
     "porque": "Sin batería no hay ganas: la primera llave del deseo es tu energía.",
     "anim": false,
     "excluye": []
    },
    {
     "id": "PP-09",
     "si": [
      "p6:apetece"
     ],
     "titular": "Esta semana, cuéntalo.",
     "pasos": [
      "Busca un momento tranquilo, fuera de la cama.",
      "Díselo así: «No es que no te quiera: es la etapa, y quiero que lo entendamos juntos».",
      "Probad a empezar por la cercanía, sin esperar a tener ganas."
     ],
     "porque": "Para muchas mujeres, el deseo llega después de empezar, con la cercanía. Hablarlo quita la presión que más lo apaga.",
     "anim": false,
     "excluye": []
    },
    {
     "id": "PP-20",
     "si": [
      "p6:excitar"
     ],
     "titular": "Esta semana, muévete antes.",
     "pasos": [
      "Veinte minutos de bici, baile o paseo rápido.",
      "Mejor en la hora antes de un momento íntimo.",
      "Y sin prisa: date más tiempo para la cercanía."
     ],
     "porque": "La excitación es, sobre todo, sangre que llega: moverte le abre el camino.",
     "anim": false,
     "excluye": [
      "MO-LIB-02"
     ]
    },
    {
     "id": "PP-21",
     "si": [
      "*"
     ],
     "titular": "Esta semana, empieza por tu batería.",
     "pasos": [
      "Acuéstate media hora antes dos noches.",
      "Pon proteína en el desayuno.",
      "Camina veinte minutos al día."
     ],
     "porque": "Sin batería no hay ganas: es la primera de las tres llaves del deseo.",
     "anim": false,
     "excluye": []
    }
   ],
   "puentes": {
    "nutrete": "Tu energía también se come: con proteína en cada comida llegas al final del día con más batería, y el deseo empieza ahí.",
    "muevete": "Moverte es la forma más directa de que llegue sangre a todo tu cuerpo, también a tu zona íntima: es la segunda llave del deseo.",
    "descansa": "Sin batería no hay ganas: antes de pensar en el deseo, protege tus horas de sueño y reparte la carga de tu día.",
    "conecta": "Hablarlo cambia mucho: contarle a tu pareja que tu deseo funciona distinto, sin culpa, quita la presión que más lo apaga."
   },
   "cierre": "Dale a tu deseo tres meses, no tres noches."
  },
  "rm": {
   "nombre": "Rendimiento Muscular",
   "preguntas": {
    "p6": {
     "escaleras": {
      "id": "MO-RM-01",
      "texto": "Subir escaleras es fuerza de piernas: sentadilla a una silla y zancadas, dos días por semana.",
      "donde": "muevete",
      "frag": "te cuesta más subir escaleras o cuestas que antes",
      "cita": "Me cuesta subir escaleras",
      "prio": 1,
      "alt": "subir escaleras o cuestas"
     },
     "botes": {
      "id": "MO-RM-02",
      "texto": "La fuerza de brazos y de agarre también se entrena: remo con banda y flexiones apoyada en la pared.",
      "donde": "muevete",
      "frag": "te cuesta más abrir botes o cargar bolsas que antes",
      "cita": "Me cuesta abrir botes",
      "prio": 2,
      "alt": "abrir botes o cargar bolsas"
     },
     "levantarme": {
      "id": "MO-RM-03",
      "texto": "Levántate de una silla sin apoyar las manos diez veces al día: ya es un ejercicio.",
      "donde": "muevete",
      "frag": "te cuesta más levantarte del suelo o de una silla que antes",
      "cita": "Me cuesta levantarme del suelo",
      "prio": 3,
      "alt": "levantarte del suelo o de una silla"
     },
     "rigida": {
      "id": "MO-RM-04",
      "texto": "Calor antes de empezar el día, con una ducha caliente o una manta térmica diez minutos, y después muévete: cada movimiento es aceite para tus articulaciones.",
      "donde": "descansa",
      "frag": "te levantas rígida por las mañanas",
      "cita": "Me levanto rígida",
      "prio": 4
     },
     "duelen": {
      "id": "MO-RM-05",
      "texto": "Más de la mitad de las mujeres en perimenopausia tienen dolor articular, y muchas veces las pruebas no muestran ningún daño: no estás gastada.",
      "donde": "caso",
      "frag": "te duelen las manos, las rodillas o los hombros",
      "cita": "Me duelen las articulaciones",
      "prio": 5
     }
    },
    "p7": {
     "poco": {
      "id": "MO-RM-06",
      "texto": "Es el mejor momento para empezar: prevenir cuesta mucho menos que recuperar.",
      "donde": "caso",
      "frag": "de momento te limita poco",
      "cita": "Me limita poco",
      "prio": 1
     },
     "bastante": {
      "id": "MO-RM-07",
      "texto": "Te está quitando cosas del día a día, y el músculo responde al entrenamiento a cualquier edad.",
      "donde": "caso",
      "frag": "te limita bastante en tu día a día",
      "cita": "Me limita bastante",
      "prio": 1
     },
     "mucho": {
      "id": "MO-RM-08",
      "texto": "Te recomendamos la pauta completa de 3 meses: la comodidad articular llega hacia el primer mes y la fuerza, hacia la semana 8 si entrenas.",
      "donde": "formula",
      "frag": "te limita mucho en tu día a día",
      "cita": "Me limita mucho",
      "prio": 1
     }
    },
    "p8": {
     "paro": {
      "id": "MO-RM-09",
      "texto": "Parar cuando duele suele empeorar la rigidez, porque el cartílago se nutre cuando la articulación se mueve. Reduce la carga o el rango, pero sigue moviéndote.",
      "donde": "muevete",
      "frag": "",
      "cita": "Cuando me duele, paro",
      "prio": 9
     },
     "sigo": {
      "id": "MO-RM-10",
      "texto": "Sigue, pero con buena técnica: una fisioterapeuta o una entrenadora te ajusta la carga en una sesión.",
      "donde": "muevete",
      "frag": "",
      "cita": "Sigo como puedo",
      "prio": 9
     },
     "adapto": {
      "id": "MO-RM-11",
      "texto": "Es justo lo que hay que hacer: adaptar, no parar.",
      "donde": "muevete",
      "frag": "",
      "cita": "Adapto el ejercicio",
      "prio": 9
     }
    }
   },
   "historia": {
    "todas": {
     "titulo": "No estás rota: estás oxidada.",
     "entrada": "Abrir un bote, subir las escaleras del metro, levantarte del suelo. Cosas que hacías sin pensar y que ahora cuestan. Hay una razón.",
     "pasos": [
      {
       "t": "Tu cuerpo tiene cerraduras para los estrógenos.",
       "d": "Tus músculos, tus tendones y tus articulaciones están preparados para recibir instrucciones de los estrógenos. Mientras están altos, ayudan a construir músculo, mantienen hidratado el cartílago, el almohadillado que protege tus articulaciones, y frenan la inflamación."
      },
      {
       "t": "Cuando bajan, te oxidas.",
       "d": "El músculo se pierde más deprisa y las articulaciones se vuelven más rígidas. Es tan frecuente que en 2024 los médicos le pusieron nombre: síndrome musculoesquelético de la menopausia. Siete de cada diez mujeres lo notan en esta etapa."
      },
      {
       "t": "Y empieza un círculo.",
       "d": "Si te duele, te mueves menos; si te mueves menos, pierdes más músculo; y con menos músculo, tus articulaciones están menos protegidas y duelen más."
      }
     ],
     "buena": "El músculo responde a cualquier edad, y el cartílago se alimenta cuando la articulación se mueve. El movimiento es tu mejor aceite, como el del Hombre de Hojalata: el círculo se puede romper, y tu plan empieza por ahí."
    }
   },
   "primerPaso": [
    {
     "id": "PP-10",
     "si": [
      "p6:rigida"
     ],
     "titular": "Mañana, calor antes de empezar el día.",
     "pasos": [
      "Una ducha caliente o una manta térmica durante diez minutos.",
      "Mueve despacio las manos, los hombros y las rodillas.",
      "Y después, a por el día."
     ],
     "porque": "El calor prepara tus articulaciones, y cada movimiento es aceite para ellas.",
     "anim": false,
     "excluye": [
      "MO-RM-04"
     ]
    },
    {
     "id": "PP-11",
     "si": [
      "*"
     ],
     "titular": "Mañana, empieza con la sentadilla a una silla.",
     "pasos": [
      "Siéntate y levántate despacio, sin apoyar las manos.",
      "Hazlo diez veces.",
      "Repítelo dos días por semana."
     ],
     "porque": "Es el primero de los cuatro ejercicios de tu plan, y el que más se nota al subir escaleras o al levantarte.",
     "anim": false,
     "excluye": []
    }
   ],
   "puentes": {
    "nutrete": "Tu músculo solo crece si tiene con qué: necesita proteína en cada comida, y el desayuno es donde más falta.",
    "muevete": "Cada movimiento es aceite para tus bisagras: el cartílago se alimenta cuando la articulación se mueve, así que moverte, aunque sea poco, ya cuenta.",
    "descansa": "Tu músculo se reconstruye mientras duermes: el descanso es la mitad del entrenamiento.",
    "conecta": "Entrenar acompañada ayuda a no dejarlo: queda con alguien dos días por semana, aunque sea para caminar."
   },
   "cierre": "Dale a tu fuerza tres meses, no tres entrenamientos."
  },
  "core": {
   "nombre": "Menopausia Core",
   "preguntas": {
    "p6_sofocos": {
     "dia": {
      "id": "MO-COR-01",
      "texto": "Vístete por capas y ten a mano un abanico: quitarte una capa a tiempo corta el sofoco antes.",
      "donde": "descansa",
      "frag": "los sofocos te pillan de día",
      "cita": "Sofocos de día",
      "prio": 1
     },
     "noche": {
      "id": "MO-COR-02",
      "texto": "Dormitorio fresco, entre 16 y 18 °C, y ropa de cama transpirable.",
      "donde": "descansa",
      "frag": "los sofocos te despiertan por la noche",
      "cita": "Los sofocos me despiertan",
      "prio": 1
     },
     "ambas": {
      "id": "MO-COR-03",
      "texto": "Los sofocos frecuentes duran de media 7,4 años: merece la pena cuidarse, no solo esperar a que pasen.",
      "donde": "caso",
      "frag": "los sofocos te pillan de día y te despiertan por la noche",
      "cita": "Sofocos de día y de noche",
      "prio": 1
     }
    },
    "p6_animo": {
     "salto": {
      "id": "MO-COR-04",
      "texto": "No es tu carácter, es la etapa. Ponle nombre en casa: «No es contigo, es la etapa» desactiva muchas discusiones.",
      "donde": "conecta",
      "frag": "saltas por cosas que antes no te afectaban",
      "cita": "Salto por cosas que antes no me afectaban",
      "prio": 1
     },
     "lloro": {
      "id": "MO-COR-05",
      "texto": "Llorar con más facilidad también forma parte de esta etapa. Hablarlo con otra mujer que esté pasando por lo mismo quita mucho peso.",
      "donde": "conecta",
      "frag": "lloras con facilidad",
      "cita": "Lloro con facilidad",
      "prio": 3
     },
     "ansiedad": {
      "id": "MO-COR-06",
      "texto": "Tres respiraciones fisiológicas cuando notes que el día se acelera: doble inhalación por la nariz y exhalación larga por la boca. Si la ansiedad te pesa mucho o dura semanas, háblalo con tu médico.",
      "donde": "descansa",
      "frag": "sientes ansiedad sin un motivo claro",
      "cita": "Siento ansiedad",
      "prio": 2
     },
     "culpa": {
      "id": "MO-COR-07",
      "texto": "La culpa alimenta el círculo. Explícalo en casa: cuando tu gente entiende lo que te pasa, todo es más fácil.",
      "donde": "conecta",
      "frag": "luego te sientes culpable",
      "cita": "Luego me siento culpable",
      "prio": 4
     }
    },
    "p6_hinchazon": {
     "comer": {
      "id": "MO-COR-08",
      "texto": "Empieza la comida por la verdura y la proteína, y camina diez minutos después.",
      "donde": "nutrete",
      "frag": "te hinchas después de comer",
      "cita": "Hinchazón después de comer",
      "prio": 1
     },
     "tarde": {
      "id": "MO-COR-09",
      "texto": "Un fermentado al día, como yogur o kéfir, y variedad de plantas cada semana: tu microbiota se vuelve menos diversa en esta etapa. Empieza por una ración y sube poco a poco.",
      "donde": "nutrete",
      "frag": "la hinchazón te llega a media tarde",
      "cita": "Hinchazón a media tarde",
      "prio": 1
     },
     "todo": {
      "id": "MO-COR-10",
      "texto": "Si la hinchazón no se va en todo el día o lleva meses, coméntalo con tu médico: puede tener otras causas.",
      "donde": "consultar",
      "frag": "estás hinchada casi todo el día",
      "cita": "Hinchazón casi todo el día",
      "prio": 1
     }
    },
    "p6_cansancio": {
     "levantar": {
      "id": "MO-COR-11",
      "texto": "Despertarte cansada aunque hayas dormido puede ser señal de un sueño poco reparador; si te pasa a menudo, coméntalo con tu médico.",
      "donde": "consultar",
      "frag": "te levantas cansada aunque hayas dormido",
      "cita": "Me levanto cansada",
      "prio": 1
     },
     "tarde": {
      "id": "MO-COR-12",
      "texto": "El bajón de media tarde suele empezar en el desayuno: con proteína, la energía aguanta hasta la comida.",
      "donde": "nutrete",
      "frag": "el cansancio te pesa sobre todo a media tarde",
      "cita": "Cansancio a media tarde",
      "prio": 1
     },
     "todo": {
      "id": "MO-COR-13",
      "texto": "Un cansancio que no se arregla descansando también es una señal. Si tus reglas son abundantes, pide que te miren el hierro.",
      "donde": "consultar",
      "frag": "estás cansada todo el día",
      "cita": "Cansada todo el día",
      "prio": 1
     }
    },
    "p7": {
     "alcohol": {
      "id": "MO-COR-14",
      "texto": "El alcohol es de los desencadenantes más habituales y, además, favorece los despertares a media noche.",
      "donde": "nutrete",
      "frag": "el alcohol",
      "cita": "Lo empeora el alcohol",
      "prio": 1,
      "alt": "lo empeora el alcohol / lo empeoran el alcohol y…"
     },
     "picante": {
      "id": "MO-COR-15",
      "texto": "Prueba dos semanas sin picante y con bebidas templadas, y apunta cómo te sientes.",
      "donde": "nutrete",
      "frag": "el picante o las bebidas calientes",
      "cita": "Lo empeora el picante",
      "prio": 2,
      "alt": "lo empeoran el picante o las bebidas calientes"
     },
     "estres": {
      "id": "MO-COR-16",
      "texto": "El estrés y los sofocos se alimentan entre sí. Si te afectan mucho, pregunta por la terapia cognitivo-conductual o la hipnosis clínica: son los tratamientos sin hormonas con más respaldo.",
      "donde": "descansa",
      "frag": "el estrés",
      "cita": "Lo empeora el estrés",
      "prio": 3,
      "alt": "lo empeora el estrés"
     },
     "dormir": {
      "id": "MO-COR-17",
      "texto": "Dormir mal acorta la mecha y enciende el termostato: tu noche también forma parte de tu plan.",
      "donde": "descansa",
      "frag": "dormir mal",
      "cita": "Lo empeora dormir mal",
      "prio": 4,
      "alt": "lo empeora dormir mal"
     },
     "no_se": {
      "id": "MO-COR-18",
      "texto": "Durante dos semanas, apunta en la app tus síntomas y lo que había justo antes: así descubrirás tus patrones.",
      "donde": "nutrete",
      "frag": "todavía no sabes qué lo empeora",
      "cita": "No sé qué lo empeora",
      "prio": 5
     }
    },
    "p8": {
     "si": {
      "id": "MO-COR-19",
      "texto": "Sigue así, y añade a tu próxima revisión la vitamina D.",
      "donde": "consultar",
      "frag": "",
      "cita": "Me hago revisiones",
      "prio": 9
     },
     "no": {
      "id": "MO-COR-20",
      "texto": "Un año antes de tu última regla, el hueso empieza a perder cerca de un 2 % al año sin que se note. En tu próxima revisión pide tensión, colesterol, glucosa, vitamina D y, según tu riesgo, densitometría.",
      "donde": "consultar",
      "frag": "",
      "cita": "No me reviso",
      "prio": 9
     }
    }
   },
   "historia": {
    "todas": {
     "titulo": "Una raíz, cinco caras.",
     "entrada": "Un día son los sofocos. Otro, un mal genio que no reconoces. Otro, una hinchazón que no se va. Parecen problemas distintos, pero casi todos nacen del mismo sitio.",
     "pasos": [
      {
       "t": "Los estrógenos visitan todo tu cuerpo.",
       "d": "Son mensajeros que llegan a casi todas las habitaciones de tu cuerpo: el cerebro, la piel, los vasos sanguíneos, los huesos y el intestino. En cada una dejan instrucciones para que todo funcione con suavidad. Cuando faltan, cada habitación lo nota a su manera."
      },
      {
       "t": "[cara]",
       "d": ""
      },
      {
       "t": "Las caras que no notas.",
       "d": "Los huesos empiezan a perder fuerza sin avisar, y el corazón pierde parte de la protección que le daban los estrógenos."
      }
     ],
     "buena": "Si todo nace de la misma raíz, tiene sentido cuidar la raíz, y no solo poner un parche a cada síntoma. De eso va tu plan."
    },
    "caras": {
     "sofocos": {
      "t": "Los sofocos.",
      "d": "En tu cerebro está el termostato que decide si tienes frío o calor. Sin estrógenos se vuelve más sensible: un cambio mínimo de temperatura dispara la alarma, y tu cuerpo intenta enfriarse de golpe. Eso es un sofoco."
     },
     "animo": {
      "t": "El ánimo.",
      "d": "Los estrógenos también influyen en las sustancias que regulan tu humor. Cuando bajan, la paciencia se acorta. Y si además duermes mal, todavía más. No es tu carácter: es la etapa."
     },
     "hinchazon": {
      "t": "La hinchazón.",
      "d": "En tu intestino viven billones de bacterias buenas, tu microbiota. Un grupo de ellas funciona como un centro de reciclaje de estrógenos: decide cuántos vuelve a aprovechar tu cuerpo y cuántos elimina. En esta etapa tu microbiota cambia, y se nota en la digestión."
     },
     "cansancio": {
      "t": "El cansancio.",
      "d": "Los estrógenos también intervienen en cómo tus células consiguen energía y en cómo duermes. Cuando bajan, y más si duermes peor, la batería se vacía antes. No es pereza: es la etapa.",
      "pendiente": true
     }
    }
   },
   "primerPaso": [
    {
     "id": "PP-12",
     "si": [
      "p6:noche",
      "p6:ambas"
     ],
     "titular": "Esta noche, dormitorio fresco y ropa de cama transpirable.",
     "pasos": [
      "Deja la habitación entre 16 y 18 °C.",
      "Usa sábanas de algodón o lino, por capas.",
      "Deja un vaso de agua fresca en la mesilla."
     ],
     "porque": "Tu termostato está más sensible: con menos calor alrededor, salta menos.",
     "anim": false,
     "excluye": [
      "MO-COR-02"
     ]
    },
    {
     "id": "PP-13",
     "si": [
      "p6:dia"
     ],
     "titular": "Durante dos semanas, apunta tus desencadenantes.",
     "pasos": [
      "Cada vez que tengas un sofoco, apunta qué había justo antes.",
      "Fíjate en el alcohol, el picante, el café muy caliente y las cenas copiosas.",
      "Al final, mira qué se repite."
     ],
     "porque": "No a todas les afecta lo mismo: conocer lo tuyo es la mitad del trabajo.",
     "anim": false,
     "excluye": []
    },
    {
     "id": "PP-14",
     "si": [
      "principal:animo"
     ],
     "titular": "Hoy, ponle nombre.",
     "pasos": [
      "Cuando notes que saltas, para un segundo.",
      "Dilo en voz alta: «No es contigo, es la etapa».",
      "Explícaselo a los tuyos en un momento tranquilo."
     ],
     "porque": "Ponerle nombre desactiva muchas discusiones y te quita culpa.",
     "anim": false,
     "excluye": [
      "MO-COR-04"
     ]
    },
    {
     "id": "PP-15",
     "si": [
      "principal:hinchazon"
     ],
     "titular": "Mañana, un fermentado.",
     "pasos": [
      "Un yogur natural o un kéfir en el desayuno.",
      "O un poco de chucrut o kimchi en la comida.",
      "Empieza por una ración y sube poco a poco."
     ],
     "porque": "Tus bacterias buenas cambian en esta etapa, y los fermentados las ayudan.",
     "anim": false,
     "excluye": [
      "MO-COR-09"
     ]
    },
    {
     "id": "PP-16",
     "si": [
      "*"
     ],
     "titular": "Esta semana, quítate una cosa de encima.",
     "pasos": [
      "Haz una lista de lo que llevas en la cabeza.",
      "Elige una cosa que pueda hacer otra persona.",
      "Pídelo hoy."
     ],
     "porque": "La carga mental también vacía la batería, y repartirla se nota antes que casi cualquier otra cosa.",
     "anim": false,
     "excluye": []
    }
   ],
   "puentes": {
    "nutrete": "Tu intestino también es parte de la raíz: las bacterias buenas que reciclan tus estrógenos se alimentan de la variedad de plantas que comes. Suma una nueva cada semana.",
    "muevete": "Moverte ayuda a más de una cara a la vez: la fuerza cuida los huesos que pierden fuerza sin avisar, y caminar cada día ayuda a tu digestión y a tu ánimo.",
    "descansa": "Los sofocos y el mal humor se alimentan del estrés del día: cinco minutos de respiración lenta al terminar la jornada bajan la alarma antes de irte a la cama.",
    "conecta": "Hablarlo con otras mujeres de tu misma etapa quita mucho peso: casi todo lo que te pasa, les ha pasado también a ellas."
   },
   "cierre": "Dale a tu raíz tres meses, no tres días."
  }
 },
 "habitos": {
  "desayuno": {
   "pilar": "nutrete",
   "opciones": {
    "cafe": {
     "id": "HA-02",
     "texto": "A tu desayuno le falta proteína, lo que mantiene tu energía estable y cuida tus músculos. Prueba con huevos revueltos o un yogur griego con fruta y frutos secos.",
     "cita": "Café con tostada o bollería",
     "vasBien": false
    },
    "proteina": {
     "id": "HA-03",
     "texto": "Vas bien: mantén la proteína en cada comida y suma un fermentado al día.",
     "cita": "Algo con proteína",
     "vasBien": true
    },
    "nada": {
     "id": "HA-04",
     "texto": "Que tu primera comida del día lleve proteína: huevos, yogur griego, queso fresco o legumbre.",
     "cita": "No desayuno",
     "vasBien": false
    }
   }
  },
  "pescado": {
   "pilar": "nutrete",
   "opciones": {
    "casi_nunca": {
     "id": "HA-05",
     "texto": "Apunta sardinas o caballa dos veces esta semana: su omega-3 forma parte de las células de tu cerebro.",
     "cita": "Pescado azul, casi nunca",
     "vasBien": false
    },
    "una": {
     "id": "HA-06",
     "texto": "Vas por buen camino: sube a dos o tres veces por semana.",
     "cita": "Pescado azul, una vez por semana",
     "vasBien": false
    },
    "dos_mas": {
     "id": "HA-07",
     "texto": "Vas muy bien: sigue así.",
     "cita": "Pescado azul, dos o más veces",
     "vasBien": true
    }
   }
  },
  "fuerza": {
   "pilar": "muevete",
   "opciones": {
    "no": {
     "id": "HA-08",
     "texto": "Empieza en casa con cuatro ejercicios, dos días por semana: sentadilla a una silla, remo con banda, zancadas y flexiones apoyada en la pared.",
     "cita": "No hago fuerza",
     "vasBien": false
    },
    "quiero": {
     "id": "HA-09",
     "texto": "Mañana, sentadilla a una silla: siéntate y levántate despacio, sin apoyar las manos, diez veces. Es el primero de cuatro ejercicios para hacer en casa dos días por semana.",
     "cita": "Quiero empezar con la fuerza",
     "vasBien": false
    },
    "a_veces": {
     "id": "HA-10",
     "texto": "Pasa a dos días fijos por semana y ponlos en el calendario como una cita.",
     "cita": "Fuerza, de vez en cuando",
     "vasBien": false
    },
    "dos_mas": {
     "id": "HA-11",
     "texto": "Que pese un poco: si haces 20 repeticiones sin esfuerzo, sube la carga.",
     "cita": "Fuerza, dos o más días",
     "vasBien": true
    }
   }
  },
  "vitd": {
   "pilar": "muevete",
   "opciones": {
    "baja": {
     "id": "HA-12",
     "texto": "Coméntalo con tu médico para que valore qué necesitas, y suma 10–20 minutos de paseo con luz natural por la mañana.",
     "cita": "Tengo la vitamina D baja",
     "vasBien": false
    },
    "bien": {
     "id": "HA-13",
     "texto": "Bien: vuelve a mirarla en tu próxima analítica.",
     "cita": "La vitamina D, bien",
     "vasBien": true
    },
    "no_se": {
     "id": "HA-14",
     "texto": "Pide la vitamina D en tu próxima analítica: muchas mujeres la tienen baja sin saberlo.",
     "cita": "No sé cómo tengo la vitamina D",
     "vasBien": false
    }
   }
  },
  "dia": {
   "pilar": "descansa",
   "opciones": {
    "energia": {
     "id": "HA-15",
     "texto": "Llegas con energía: protege lo que te funciona.",
     "cita": "Llego con energía",
     "vasBien": true
    },
    "cansada_bien": {
     "id": "HA-16",
     "texto": "Levántate siempre a la misma hora, también el fin de semana: es el ancla más potente de tu reloj interno.",
     "cita": "Llego cansada, pero bien",
     "vasBien": false
    },
    "agotada": {
     "id": "HA-17",
     "texto": "Cinco minutos de respiración lenta al acabar el día, y reparte la carga: lo que sale de tu lista mental deja sitio a todo lo demás.",
     "cita": "Llego agotada y con la cabeza llena",
     "vasBien": false
    }
   }
  },
  "conecta": {
   "pilar": "conecta",
   "opciones": {
    "si": {
     "id": "HA-18",
     "texto": "Tener con quién hablarlo es una de tus mejores herramientas: úsala.",
     "cita": "Tengo con quién hablarlo",
     "vasBien": true
    },
    "medias": {
     "id": "HA-19",
     "texto": "Esta semana, una conversación de verdad con alguien que te haga bien, mejor por la tarde que a las once de la noche.",
     "cita": "Me siento acompañada a medias",
     "vasBien": false
    },
    "sola": {
     "id": "HA-20",
     "texto": "Sentirte sola mantiene la alarma encendida. Esta semana, haz un plan con alguien que te haga bien, con fecha y hora. Y recuerda que más de 800.000 mujeres de nuestra comunidad viven lo mismo que tú.",
     "cita": "Me siento bastante sola",
     "vasBien": false
    }
   }
  }
 },
 "productos": {
  "sueno": {
   "handle": "sueno",
   "nombre": "Sueño",
   "color": "#163D85",
   "noche": true,
   "claim": "Volver a dormir. Sin melatonina y sin levantarte espesa.",
   "desc": "Fórmula de descanso que actúa desde el eje intestino–cerebro: un probiótico, aminoácidos y extractos vegetales que te ayudan a conciliar el sueño y a mantenerlo durante toda la noche.",
   "sellos": [
    "Sin melatonina",
    "Sin hormonas",
    "Compatible con terapia hormonal",
    "Firma médica"
   ],
   "beneficios": [
    [
     "Concilias el sueño más fácil",
     "L-glicina"
    ],
    [
     "Descansas toda la noche, con menos despertares",
     "GABA, valeriana, melisa y el probiótico Levilactobacillus brevis BIO 5542"
    ],
    [
     "Calma la mente acelerada, sin sedarte",
     "L-teanina"
    ],
    [
     "Descanso más profundo y reparador",
     "Pasiflora y amapola de California"
    ]
   ],
   "unica": [
    [
     "Sin melatonina, a propósito.",
     "Va a la causa de tus despertares, no a la hora del reloj."
    ],
    [
     "Un probiótico para dormir.",
     "Ayuda a tu intestino a producir GABA, el freno de tu cerebro."
    ],
    [
     "Hecha para las noches de esta etapa.",
     "Freno, calma y calor en un solo sobre."
    ]
   ],
   "toma": "1 sobre disuelto en agua, entre 30 y 60 minutos antes de acostarte, después de cenar.",
   "tomaCorta": "entre 30 y 60 minutos antes de acostarte"
  },
  "niebla": {
   "handle": "niebla-mental",
   "nombre": "Niebla Mental",
   "color": "#3FA2DB",
   "claim": "Recupera el foco y la claridad. Sin cafeína y sin acelerarte.",
   "desc": "Fórmula de neuronutrición diseñada para el cerebro de la mujer: Cognizin®, BacoMind® y extractos vegetales que trabajan a la vez la energía mental, el foco y la memoria, sin estimulantes.",
   "sellos": [
    "Sin cafeína",
    "Sin hormonas",
    "Compatible con terapia hormonal",
    "Firma médica"
   ],
   "beneficios": [
    [
     "Pensar cansa menos",
     "Ginseng y L-carnitina"
    ],
    [
     "Vuelven el foco y la concentración",
     "Cognizin® y centella asiática"
    ],
    [
     "Una memoria más ágil",
     "BacoMind® (bacopa)"
    ],
    [
     "Cuida la estructura de tus neuronas",
     "Fosfatidilserina"
    ]
   ],
   "unica": [
    [
     "Sin estimulantes.",
     "No te acelera: puedes tomarla aunque duermas mal y junto a Sueño."
    ],
    [
     "Dos activos patentados.",
     "Cognizin® y BacoMind®, con sus propios estudios."
    ],
    [
     "Para un cerebro en obras, no para un examen.",
     "Energía, foco y memoria a la vez."
    ]
   ],
   "toma": "2 cápsulas, 5 minutos antes del desayuno.",
   "tomaCorta": "5 minutos antes del desayuno"
  },
  "libido": {
   "handle": "libido",
   "nombre": "Libido",
   "color": "#EC6083",
   "claim": "Tus ganas, de vuelta. Sin hormonas.",
   "desc": "La fórmula multidiana que no busca un efecto de una noche, sino crear las condiciones para que tu cuerpo vuelva a responder. Trabaja por capas la energía, la circulación y el deseo, con cordyceps y Pycnogenol®.",
   "sellos": [
    "Sin hormonas",
    "Compatible con terapia hormonal",
    "Hongo medicinal",
    "Firma médica"
   ],
   "beneficios": [
    [
     "Más energía y vitalidad",
     "Cordyceps"
    ],
    [
     "Mejor circulación y sensibilidad íntima",
     "Pycnogenol® y ginkgo"
    ],
    [
     "Apoya el deseo y la motivación",
     "Maca, tribulus y fenogreco"
    ],
    [
     "Acompaña la disposición al disfrute",
     "Damiana"
    ],
    [
     "Menos cansancio",
     "Vitaminas C y B5"
    ]
   ],
   "unica": [
    [
     "Trabaja la cadena entera, en orden.",
     "Primero la energía, luego la circulación y al final el deseo."
    ],
    [
     "No busca un efecto de una noche.",
     "Crea las condiciones para que tu cuerpo vuelva a responder por sí mismo."
    ],
    [
     "Compatible con la terapia hormonal.",
     "Muchas mujeres con THM siguen notando el deseo apagado."
    ]
   ],
   "toma": "2 cápsulas, 5 minutos antes del desayuno.",
   "tomaCorta": "5 minutos antes del desayuno"
  },
  "rm": {
   "handle": "rendimiento-muscular",
   "nombre": "Rendimiento Muscular",
   "color": "#006B2D",
   "claim": "Tu fuerza y tu autonomía. Sin hormonas.",
   "desc": "La fórmula multidiana que no solo contiene Creapure®, la creatina más pura del mercado, sino también otros activos patentados: PeptiStrong™ para la fuerza y la recuperación, Ovomet® para tus articulaciones y DigeZyme™ para que tu cuerpo lo absorba mejor.",
   "sellos": [
    "Sin hormonas",
    "Compatible con terapia hormonal",
    "Dosis de ensayo clínico",
    "Firma médica"
   ],
   "beneficios": [
    [
     "Más fuerza, masa y recuperación",
     "Creapure® y PeptiStrong™"
    ],
    [
     "Articulaciones y cartílago protegidos",
     "Ovomet®"
    ],
    [
     "Energía y menos fatiga",
     "Vitaminas B"
    ],
    [
     "Mejor tolerancia y absorción",
     "Glutamina y DigeZyme™"
    ]
   ],
   "unica": [
    [
     "Músculo y articulaciones en un solo cacito.",
     "El músculo protege tus articulaciones: tiene sentido cuidarlos juntos."
    ],
    [
     "Las cantidades de los estudios.",
     "3 g de creatina y la cantidad de Ovomet® de su ensayo."
    ],
    [
     "Para la fuerza de tu día a día.",
     "No hace falta que seas deportista."
    ]
   ],
   "toma": "1 cacito (10 g) disuelto en 150 ml de agua, 5 minutos antes del desayuno. Contiene huevo.",
   "tomaCorta": "5 minutos antes del desayuno"
  },
  "core": {
   "handle": "menopausia-core",
   "nombre": "Menopausia Core",
   "color": "#D9B23A",
   "claim": "No te da hormonas. Ayuda a tu cuerpo a aprovechar mejor las suyas.",
   "desc": "La fórmula multidiana que trabaja la menopausia desde el intestino. Su corazón es Gyntima Meno®, un probiótico que cuida el estroboloma, las bacterias que reciclan tus estrógenos, y así actúa sobre la raíz del conjunto de síntomas.",
   "sellos": [
    "Sin hormonas",
    "Enfoque microbiota",
    "1 cápsula al día",
    "Firma médica"
   ],
   "beneficios": [
    [
     "Trabaja la raíz de los síntomas, incluida la inflamación",
     "Gyntima Meno®"
    ],
    [
     "Alivia sofocos y sudoración",
     "Salvia"
    ],
    [
     "Estabiliza el ánimo y el descanso",
     "Safrasol® y Menoduo®"
    ],
    [
     "Cuida corazón y circulación",
     "Pycnogenol® y olivo"
    ],
    [
     "Protege tus huesos",
     "Vitaminas D3 y K2"
    ]
   ],
   "unica": [
    [
     "Empieza por tu intestino.",
     "Cuida las bacterias que reciclan tus estrógenos."
    ],
    [
     "Sin hormonas.",
     "Ayuda a tu cuerpo a aprovechar mejor las suyas."
    ],
    [
     "Las cantidades de los estudios.",
     "30 mg de azafrán, como en el ensayo con mujeres en posmenopausia."
    ],
    [
     "Una cápsula en lugar de una estantería.",
     "Una rutina sencilla es la que se mantiene."
    ]
   ],
   "toma": "1 cápsula, 5 minutos antes del desayuno.",
   "tomaCorta": "5 minutos antes del desayuno",
   "thm": "No lleva hormonas, pero el lúpulo es un fitoestrógeno: una sustancia de una planta que se parece a los estrógenos. Si ya tomas estrógenos con tu terapia, no tiene sentido sumar más."
  },
  "extraordinaria": {
   "handle": "aceite-intimo-extraordinaria",
   "nombre": "Extraordinaria",
   "color": "#111111",
   "extra": true,
   "claim": "2 gotas para tu vulva. Un mundo de diferencia.",
   "desc": "Nutre, repara e hidrata la piel externa de la vulva con aceite de oliva virgen extra ecológico ozonizado y aceites botánicos reparadores. Fórmula 100 % activa, sin agua y sin conservantes. No es un lubricante.",
   "porque": "Con menos estrógenos, la piel de tu zona íntima se vuelve más fina y más seca, y eso no tienes por qué aguantarlo."
  }
 },
 "roles": {
  "lidera": "Directo a lo que más te pesa",
  "tambien": "Para lo que también notas",
  "raiz": "Para cuidar la raíz",
  "intima": "Para tu zona íntima"
 },
 "especiales": {
  "thm_con_otros": "Como sigues terapia hormonal, no te recomendamos Menopausia Core: tu tratamiento ya trabaja la parte hormonal. Tu plan va directo a lo que más te pesa, con fórmulas compatibles con tu THM.",
  "thm_solo_hormonal": "Con THM, tu tratamiento ya trabaja la parte hormonal, así que esta vez no te recomendamos ninguna fórmula. Tu plan empieza por los hábitos que más te pueden ayudar.",
  "otro_hormonal": "Como tomas un tratamiento hormonal, no te recomendamos Menopausia Core. Tu plan va directo a lo que más te pesa.",
  "thm_no_se": "Si tomas terapia hormonal, no combines Menopausia Core con ella: el resto de fórmulas sí son compatibles. Ante la duda, consúltalo con tu ginecóloga.",
  "menos45": "Con tu edad y tu regla como siempre, empezamos por lo que más te pesa. Si con los meses notas sofocos o cambios en tu regla, vuelve a hacer el test.",
  "solo_fuerza": "Tu plan va directo a tu músculo: Rendimiento Muscular cuida músculo y articulaciones a la vez, y saca más partido a tu entrenamiento.",
  "fuera": "Todavía no enviamos suplementos a tu país, pero tu Plan W sigue siendo para ti: tienes tus hábitos, tus guías completas y la app de Womanhood."
 },
 "textos": {
  "datoCierre": "No eres la única, y lo que te pasa tiene una explicación muy concreta. Te la contamos.",
  "pilaresTitulo": "Tus 5 pilares, escritos con lo que nos has contado.",
  "pilaresIntro": "No necesitas cambiar tu vida entera. Estos son los cambios que más pueden ayudarte a ti.",
  "refuerza": "Para lo que los hábitos no alcanzan solos.",
  "notaEstudios": "Los estudios se hicieron con cada ingrediente por separado, no con la fórmula.",
  "lodecimos": "Y lo decimos como es: si con lo que has leído ya sabes por dónde empezar, no necesitas comprar nada. Tu fórmula está para cuando los hábitos no bastan, y para acompañarte mientras los cambias.",
  "consultarSueno": "Si dormir mal se repite varias noches por semana, afecta a tu día a día o lleva tiempo pasando, consúltalo con tu médico. La terapia cognitivo-conductual para el insomnio, un tratamiento con una psicóloga que reeduca tus hábitos y pensamientos sobre el sueño, es la que más respaldo tiene.",
  "cierreSinFormula": "Empieza hoy por tu primer paso. Lo demás llega paso a paso.",
  "email": "Te hemos enviado tu Plan W a tu email, junto con tus guías.",
  "pie": "Este contenido tiene finalidad divulgativa y no sustituye la valoración de un profesional sanitario.",
  "pago": [
   "Pago seguro · 3 plazos sin intereses con Klarna",
   "Visa, Mastercard, Amex, PayPal, Apple Pay, Google Pay y Bizum",
   "Sale en 24 h laborables · Envío gratis desde 49 €"
  ],
  "silvia": "Médico digestivo y experta en microbiota. Formula nuestras fórmulas.",
  "enrique": "Director farmacéutico. Su equipo revisa cada activo y cada dosis.",
  "sellosConfianza": [
   "Sin hormonas",
   "Las cantidades de los estudios",
   "Fabricado en España"
  ],
  "protocolos": {
   "sueno": "el protocolo de las 3:47"
  }
 },
 "faq": [
  {
   "q": "Ya probé suplementos y no noté nada. ¿Por qué este sería distinto?",
   "a": "Importan la dosis y el enfoque: cada activo va en la cantidad elegida para la fórmula, y los ingredientes se combinan para trabajar sobre distintos frentes de tu síntoma, no sobre uno solo."
  },
  {
   "q": "[varias]",
   "a": "[varias]"
  },
  {
   "q": "¿Cuándo notaré resultados?",
   "a": "Algunas cosas se notan en las primeras semanas, pero cada fórmula necesita su tiempo para trabajar al completo. Por eso la pauta recomendada son 3 meses."
  },
  {
   "q": "¿Puedo tomarlas con mi medicación?",
   "a": "Si tomas medicación o tienes una enfermedad, consúltalo antes con tu médico o tu farmacéutico. Y si tienes dudas, escríbenos: te responde nuestro equipo farmacéutico."
  },
  {
   "q": "¿Cómo funciona mi descuento?",
   "a": "Con 2 productos, −15 % automático; con 3 o más, −20 %. Si empiezas por una unidad, tu código [codigo] te da un −15 % hasta el [fecha]. Los descuentos no se acumulan."
  }
 ],
 "demo": {
  "carmen": {
   "nombre": "Carmen",
   "pais": "ES",
   "edad": "45-49",
   "regla": "irregular",
   "principal": "sueno",
   "tambien": [
    "niebla"
   ],
   "modulo": {
    "p6": [
     "madrugada",
     "cabeza"
    ],
    "p7": "casi_todas",
    "p8": "movil"
   },
   "habitos": {
    "desayuno": "cafe",
    "pescado": "casi_nunca",
    "fuerza": "quiero",
    "vitd": "no_se",
    "dia": "agotada",
    "conecta": "medias"
   },
   "thm": "no"
  },
  "ana": {
   "nombre": "Ana",
   "pais": "ES",
   "edad": "55mas",
   "regla": "mas2",
   "principal": "sofocos",
   "tambien": [
    "hinchazon",
    "cansancio"
   ],
   "modulo": {
    "p6": [
     "noche"
    ],
    "p7": [
     "alcohol",
     "dormir"
    ],
    "p8": "no"
   },
   "habitos": {
    "desayuno": "proteina",
    "pescado": "una",
    "fuerza": "no",
    "vitd": "no_se",
    "dia": "cansada_bien",
    "conecta": "si"
   },
   "thm": "no"
  },
  "lucia": {
   "nombre": "Lucía",
   "pais": "ES",
   "edad": "menos45",
   "regla": "igual_con_cambios",
   "principal": "niebla",
   "tambien": [
    "deseo"
   ],
   "modulo": {
    "p6": [
     "hilo",
     "concentrar"
    ],
    "p7": "a_veces",
    "p8": "3mas"
   },
   "habitos": {
    "desayuno": "nada",
    "pescado": "una",
    "fuerza": "a_veces",
    "vitd": "bien",
    "dia": "agotada",
    "conecta": "sola"
   },
   "thm": "no"
  },
  "marta": {
   "nombre": "Marta",
   "pais": "ES",
   "edad": "50-54",
   "regla": "menos12",
   "principal": "sequedad",
   "tambien": [
    "sofocos"
   ],
   "modulo": {
    "p6": [
     "sensibilidad",
     "cansada"
    ],
    "p7": "justa"
   },
   "habitos": {
    "desayuno": "cafe",
    "pescado": "dos_mas",
    "fuerza": "no",
    "vitd": "baja",
    "conecta": "medias"
   },
   "thm": "no"
  },
  "elena": {
   "nombre": "Elena",
   "pais": "ES",
   "edad": "50-54",
   "regla": "irregular",
   "principal": "fuerza",
   "tambien": [],
   "modulo": {
    "p6": [
     "escaleras",
     "rigida"
    ],
    "p7": "bastante",
    "p8": "paro"
   },
   "habitos": {
    "desayuno": "cafe",
    "pescado": "una",
    "fuerza": "no",
    "vitd": "no_se",
    "dia": "cansada_bien",
    "conecta": "si"
   },
   "thm": "no"
  },
  "rosa": {
   "nombre": "Rosa",
   "pais": "ES",
   "edad": "50-54",
   "regla": "1a2",
   "principal": "sueno",
   "tambien": [
    "animo"
   ],
   "modulo": {
    "p6": [
     "calor",
     "agotada"
    ],
    "p7": "3-4",
    "p8": "vueltas"
   },
   "habitos": {
    "desayuno": "proteina",
    "pescado": "casi_nunca",
    "fuerza": "dos_mas",
    "vitd": "bien",
    "dia": "cansada_bien",
    "conecta": "si"
   },
   "thm": "si"
  },
  "pilar": {
   "nombre": "Pilar",
   "pais": "ES",
   "edad": "55mas",
   "regla": "mas2",
   "principal": "sofocos",
   "tambien": [
    "animo"
   ],
   "modulo": {
    "p6": [
     "ambas"
    ],
    "p7": [
     "estres"
    ],
    "p8": "si"
   },
   "habitos": {
    "desayuno": "proteina",
    "pescado": "dos_mas",
    "fuerza": "a_veces",
    "vitd": "bien",
    "dia": "energia",
    "conecta": "si"
   },
   "thm": "si"
  },
  "sofia": {
   "nombre": "Sofía",
   "pais": "MX",
   "edad": "50-54",
   "regla": "irregular",
   "principal": "cansancio",
   "tambien": [
    "sueno"
   ],
   "modulo": {
    "p6": [
     "todo"
    ],
    "p7": [
     "no_se"
    ],
    "p8": "no"
   },
   "habitos": {
    "desayuno": "cafe",
    "pescado": "casi_nunca",
    "fuerza": "no",
    "vitd": "no_se",
    "dia": "agotada",
    "conecta": "medias"
   },
   "thm": "no"
  }
 }
};